import { Box, IconButton, Tooltip, Typography } from "@mui/material";
import { Iconify } from "app/components/Iconify";

type NotificationPopoverSummaryProps = {
  markAllAsRead: () => void;
  totalUnRead: number;
};

export const NotificationPopoverSummary = ({
  markAllAsRead,
  totalUnRead,
}: NotificationPopoverSummaryProps) => {
  return (
    <Box alignItems="center" display="flex" sx={{ pl: 2.5, pr: 1.5, py: 2 }}>
      <Box sx={{ flexGrow: 1 }}>
        <Typography variant="subtitle1">Notifications</Typography>
        <Typography sx={{ color: "text.secondary" }} variant="body2">
          You have {totalUnRead} unread messages
        </Typography>
      </Box>

      {totalUnRead > 0 && (
        <Tooltip title=" Mark all as read">
          <IconButton color="primary" onClick={markAllAsRead}>
            <Iconify icon="solar:check-read-outline" />
          </IconButton>
        </Tooltip>
      )}
    </Box>
  );
};
